import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PAGE_NAMES } from 'src/app/service/ansokan-form-builder/application-names';
import { getErrorText } from 'src/app/service/ansokan-form-builder/validator-errors';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';

@Component({
    selector: 'app-special-education',
    styleUrls: ['./special-education.component.scss'],
    templateUrl: './special-education.component.html',
    standalone: false
})
export class SpecialEducationComponent implements OnInit {

  public specialEducationTeacher: UntypedFormControl;

  constructor(private service: AnsokanFormGroupService) { }

  public ngOnInit() {
    // Set page group.
    const group = this.service.get(PAGE_NAMES.SPECIAL_EDUCATION.KEY);
    // Get controls.
    this.specialEducationTeacher = group.get(PAGE_NAMES.SPECIAL_EDUCATION.SPECIAL_EDUCATION_TEACHER) as UntypedFormControl;
  }

  public get error(): string {
    return getErrorText(this.specialEducationTeacher);
  }
}
